module.exports = __webpack_public_path__ + "e56ab242dbc8e85cbb0a29d07fafb39a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-122.svg
// module id = 562
// module chunks = 0